import PhoneCarousel from './PhoneCarousel';
import type { Who as WhoType } from '@/types/referAndEarn';
interface WhoProps {
  who: WhoType;
}
const Who = ({
  who
}: WhoProps) => <section className="@container relative @3xl:my-10 my-5" data-sentry-component="Who" data-sentry-source-file="Who.tsx">
    <h2 className="fl-text-2xl/3xl fl-mb-8/12 special-page-container @3xl:hidden text-left font-semibold sm:text-center">
      Who we work with
    </h2>
    <PhoneCarousel items={who} data-sentry-element="PhoneCarousel" data-sentry-source-file="Who.tsx" />
  </section>;
export default Who;